import SortIndexRequest from '../../../../Spirit/Common/Helpers/Models/SortIndexRequest';

export default class ChangeSortIndexRequest  {
	SortIndices: Array<SortIndexRequest> = null;
	constructor(obj?: Partial<ChangeSortIndexRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
